import styled from 'styled-components'
import { Button } from '@mui/material';
import {StyledButton} from "../Buttons/DefaultButton/DefaultButton.styles";

export const Container = styled.form<{isSignUpPage?: boolean; coverViewport?: boolean; reserveTopNav?: boolean}>`
    display: flex;
    flex-direction: column;
    position: fixed;
    inset: 0;
    z-index: 120;
    height: 100vh;
    max-height: 100dvh;
    background-color: white;
    padding: 0;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;

    ${(props) => props.coverViewport ? `
        position: fixed;
        inset: 0;
        z-index: 120;
        width: 100%;
    ` : ''}

    /* T2-6717: sit below TalentNavbar so bell + hamburger stay usable */
    ${(props) => props.reserveTopNav ? `
        top: var(--talent-navbar-height, 56px);
        height: calc(100vh - var(--talent-navbar-height, 56px));
        max-height: calc(100dvh - var(--talent-navbar-height, 56px));
        z-index: 110;
    ` : ''}
    
    .modalBody {
        margin: 0 auto;
        padding: 0.5rem 1rem 0;
        flex: 1 1 auto;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        width: 100%;
        max-width: 600px;
        box-sizing: border-box;
        scroll-padding-top: var(--native-safe-area-top, env(safe-area-inset-top, 0px));
        
        @media (min-width: 1200px) {
            max-width: 900px;
            padding-left: 2rem;
            padding-right: 2rem;
        }
    }
    
    .modalFooter {
        text-align: center;
        margin-top: 0.5rem;
        padding-top: 0.5rem;
        padding-bottom: calc(1rem + env(safe-area-inset-bottom));
        position: relative;
        z-index: 10;
        width: 100%;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
        padding-left: 1rem;
        padding-right: 1rem;
        box-sizing: border-box;
        
        @media (min-width: 1200px) {
            max-width: 900px;
            padding-left: 2rem;
            padding-right: 2rem;
        }
    }
    
    .stickyBottom {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        max-width: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: ${props => props.isSignUpPage ? 'start' : 'center'};
        background-color: white;
        box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
        padding: 0.5rem 1rem calc(1rem + env(safe-area-inset-bottom));
        box-sizing: border-box;

        .submitButton {
            margin: 0 auto 0.5rem !important;
            max-width: 30rem;
            width: 100%;
        }

        .onCloseBtn {
            max-width: 30rem;
        }
    }
    
    .submitButton {
        margin-bottom: 1rem !important;
    }
    
    .marginBody {
        margin-bottom: calc(6rem + env(safe-area-inset-bottom));
        padding-bottom: 1.5rem;
    }
    
    @media (max-width: 768px) {
        .modalBody {
            padding-top: 0.25rem;
        }
        .marginBody {
            margin-bottom: calc(6rem + env(safe-area-inset-bottom));
            padding-bottom: 1.5rem;
        }
    }
`

export const UnderlineTextButton = styled(Button)({
    textTransform: 'none', 
    textDecoration: 'underline',
    fontWeight: '600',
    cursor: 'pointer',  // Ensures cursor is always a pointer
  '&:hover': {
    textDecoration: 'underline',  // Keeps underline on hover
    backgroundColor: 'transparent',  // Prevents background color change on hover
  },
  '&:focus': {
    textDecoration: 'underline',  // Keeps underline on focus
    backgroundColor: 'transparent',  // Prevents background color change on focus
  },
  '&:active': {
    textDecoration: 'underline',  // Keeps underline when active
    backgroundColor: 'transparent',  // Prevents background color change when active
  },
    '&::first-letter': {
      textTransform: 'uppercase'
    },
    '& .MuiButton-label': {
      textTransform: 'lowercase',
      '&::first-letter': {
        textTransform: 'uppercase'
      }
    },
    '& .MuiButton-label::after': {
      content: '" "',  // Add a space after each word
      whiteSpace: 'pre'  // Preserve the space
    }
  });

  export const PrimaryButton = styled(StyledButton)`
    max-width: 30rem !important;
    margin: auto !important;
    position: relative;
    z-index: 1;
    pointer-events: auto;
  `

  export const DeleteButton = styled(StyledButton)`
  max-width: 15rem !important;
  margin: 1rem auto !important;
  border-color: var( --primary-main, #FB7672) !important;
  color: var( --primary-main, #FB7672) !important;
  
`